@if (notificationForm && notificationForm.get('phone')) {
  <form [formGroup]="notificationForm" class="flex flex-col gap-20" (ngSubmit)="updateNotificationPreferences()">
    <div class="flex flex-col gap-20">
      <!-- Notification Type Checkboxes -->
      <div formGroupName="notificationTypes">
        <span class="flex flex-col">
          <span class="fw-500">The patient would like notifications via:</span>
          @for (notificationType of notificationTypes; track notificationType.name) {
            <mat-checkbox class="checkbox" [formControlName]="notificationType.name">
              {{ notificationType.description }}
              @if (notificationType.notificationTypeId === 4) {
                <span class="fs-12 fw-300 italic">(Data charges may apply)</span>
              }
            </mat-checkbox>
          }
        </span>
      </div>
      <div class="flex flex-col gap-20">
        <span class="fw-500">Please verify the patient contact details:</span>
        <!-- Email Field -->
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" />
          @if (notificationForm.get('email')?.hasError('required')) {
            <mat-error> Email is required. </mat-error>
          }
          @if (notificationForm.get('email')?.hasError('email')) {
            <mat-error> Enter a valid email. </mat-error>
          }
        </mat-form-field>
        <!-- Phone Field -->
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Phone Number</mat-label>
          <input type="tel" matInput [formControl]="phoneControl" mask="(000) 000-0000" />
          @if (notificationForm.get('phone')?.hasError('required')) {
            <mat-error>Phone number is required.</mat-error>
          }
          @if (notificationForm.get('phone')?.hasError('mask')) {
            <mat-error id="errMobilePhoneLength" data-test="matErrMobilePhoneLength">Must be 10 digits.</mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <!-- Form-level, not bound to a control: the API names the offending field in the message text,
         and that text is the whole of the per-field behaviour this screen promises. Rendered inside
         the button container so it cannot scroll away from the Save it refers to, which is pinned. -->
    @if (showSaveButton) {
      <div class="btn-container">
        @if (errorMessage) {
          <p class="save-error" role="alert" data-testid="notification-preferences-save-error">{{ errorMessage }}</p>
        }
        <!-- Disabled while in flight because the save overlay is dismissible: once the patient has
             released the page, this is the only thing stopping a second concurrent PUT. -->
        <button id="btnRequest" mat-flat-button class="primary-btn" [disabled]="isSaving">Save</button>
      </div>
    } @else if (errorMessage) {
      <p class="save-error" role="alert" data-testid="notification-preferences-save-error">{{ errorMessage }}</p>
    }
  </form>
}
<app-progress-spinner-overlay [displayProgressSpinner]="isSaving" [releasable]="true"></app-progress-spinner-overlay>
